<div class="order-pdf-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>picture_as_pdf</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Orden de Servicio</h2>
      <p class="dialog-header__context">{{ orderLabel }}</p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'loading'">
    <div class="dialog-body--center">
      <mat-spinner [diameter]="40"></mat-spinner>
      <p class="state-title">Cargando PDF</p>
      <p class="state-subtitle">Preparando la vista previa del documento...</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'generating'">
    <div class="dialog-body--center">
      <mat-spinner [diameter]="40"></mat-spinner>
      <p class="state-title">Generando PDF</p>
      <p class="state-subtitle">
        El documento se está preparando. Puedes esperar aquí; se mostrará automáticamente.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'error'">
    <div class="alert alert--error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong *ngIf="errorTitle">{{ errorTitle }}</strong>
        <span>{{ errorMessage }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body dialog-body--viewer" *ngIf="state === 'view'">
    <iframe
      *ngIf="safePdfUrl"
      class="pdf-viewer"
      [src]="safePdfUrl"
      title="Vista previa de la Orden de Servicio"
    ></iframe>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      mat-stroked-button
      type="button"
      class="co-btn co-btn--ghost"
      (click)="close()"
    >
      Cerrar
    </button>

    <button
      *ngIf="state === 'view'"
      mat-flat-button
      type="button"
      class="co-btn co-btn--primary"
      [disabled]="downloading"
      (click)="downloadPdf()"
    >
      <mat-spinner *ngIf="downloading" [diameter]="18"></mat-spinner>
      <span *ngIf="!downloading">Descargar</span>
      <span *ngIf="downloading">Descargando...</span>
    </button>

    <button
      *ngIf="showRetryAction || showRefreshAction"
      mat-flat-button
      type="button"
      class="co-btn co-btn--primary"
      [disabled]="retrying"
      (click)="retry()"
    >
      <mat-spinner *ngIf="retrying" [diameter]="18"></mat-spinner>
      <span *ngIf="!retrying">{{ showRefreshAction ? 'Actualizar' : 'Reintentar' }}</span>
      <span *ngIf="retrying">{{ showRefreshAction ? 'Actualizando...' : 'Reintentando...' }}</span>
    </button>
  </mat-dialog-actions>
</div>
